<div class="splash-a">

  <!-- Hero -->
  <div class="section-hero">
    <div class="spotlight">
      <div class="head">
        <div class="container">
          <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <br class="hide-sm"/>
            <br class="hide-sm"/>
            <br class="hide-sm"/>
            <div class="text-center">
              <h1>One pass. Thousands of seats.</h1>
              <h2 class="short-top">Drop in to beautiful workspaces all around your city.</h2>
              <br/>
              <section class="cta">
                <a routerLink="/join" class="" role="button">
                  <button>Join Croissant</button>
                </a>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Tagline -->
  <div class="section-tagline">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="text-center">
            <p class="blurbs">
              Croissant makes it easy to find workspaces on the go. Try new coworking spaces or drop by your
              comfortable favorites. Our membership allows you to be productive wherever your life takes you.
            </p>
          </div>
        </div>
      </div>
    </div>

    <br class="hide-sm hide-md"/>
    <br class="hide-sm hide-md"/>
  </div>

  <!-- Steps -->
  <div class="section-steps">
    <br/>
    <br/>
    <br/>

    <!-- Not mobile -->
    <div class="hide-sm hide-md">
      <div class="container">
        <div class="row">

          <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div class="row">
              <div class="col-12 col-md-5 col-lg-5 col-xl-4">
                <picture>
                  <source srcset="/images/splash/iphone6.webp" type="image/webp">
                  <img src="/images/splash/iphone6.png" alt="Croissant mobile app on iPhone" class="img-responsive workspace-image"/>
                </picture>
              </div>
              <div class="col-12 col-md-7 col-lg-7 col-xl-8" style="padding-left: 40px">
                <h2>How it works</h2>
                <br/>
                <div class="row">
                  <div class="col-3 col-md-2">
                    <div class="number-circle">1</div>
                  </div>
                  <div class="col-9 col-md-10">
                    <h3 style="margin-top: 15px;">Choose from thousands of seats</h3>
                    <p>Find a space nearby to meet, work, &amp; focus on your projects.</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 col-md-2">
                    <div class="number-circle">2</div>
                  </div>
                  <div class="col-9 col-md-10">
                    <h3 style="margin-top: 15px;">Check in with the app</h3>
                    <p>Drop by when you need the space and check in for instant access.</p>
                  </div>
                </div>
                <div class="row">
                  <div class="col-3 col-md-2">
                    <div class="number-circle">3</div>
                  </div>
                  <div class="col-9 col-md-10">
                    <h3 style="margin-top: 15px;">Plug in and get to work</h3>
                    <p>Fast wifi, coffee, plugs, and like-minded people at each space.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Mobile -->
    <div class="hide-lg hide-xl hide-xxl">
      <div class="container">
        <div class="row">
          <div class="col">
            <h2>How it works</h2>
            <br/>
            <h3>1. Choose from thousands of seats</h3>
            <p>Find a space nearby to meet, work, &amp; focus on your projects.</p>
            <h3>2. Check in with the app</h3>
            <p>Drop by when you need the space and check in for instant access.</p>
            <h3>3. Plug in and get to work</h3>
            <p>Fast wifi, coffee, plugs, and like-minded people at each space.</p>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>


  <!-- Map -->
  <div class="section-map">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="row">
            <div class="col-12 col-md-6">
              <h2>Find workspaces near you</h2>
              <br/>
              <p>Your membership gives you access to countless options around your neighborhood. It's easy to be more productive when you're on the go.</p>
              <a class="btn btn-yellow" routerLink="/discover" role="button">Show full map &rarr;</a>
              <br/>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-md-6">
              <a routerLink="/discover">
                <picture>
                  <source srcset="/images/splash/map.webp" type="image/webp">
                  <img src="/images/splash/map.jpg" alt="Map showing coworking spaces" class="img-responsive"/>
                </picture>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>

  <!-- Remotes -->
  <div class="section-remotes">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="row">
            <div class="col-12 col-md-6 order-md-2">
              <h2>Reinvent the way your remote team works</h2>
              <br/>
              <p>Say hello to happier, more productive teams. Give your employees flexible access to workspaces around the world</p>
              <a class="btn btn-more-info" href="/team-plans" role="button">Get more information &rarr;</a>
              <br/>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-md-6 order-md-1">
              <picture>
                <source srcset="/images/splash/business.webp" type="image/webp">
                <img src="/images/splash/business.png" alt="Business networking illustration" class="img-responsive"/>
              </picture>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>

  <!-- Rates -->
  <div class="section-rates">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="row">
            <div class="col-12 col-md-6">
              <h2>Save over 50% off drop-in rates</h2>
              <br/>
              <p>Book through Croissant for the best rates on coworking space and private conference rooms</p>
              <a class="btn btn-yellow" routerLink="/discover" role="button">Find your space &rarr;</a>
              <br/>
              <br/>
              <br/>
            </div>

            <div class="col-12 col-md-6">
              <a routerLink="/discover">
                <picture>
                  <source srcset="/images/splash/place-werkwise.webp" type="image/webp">
                  <img src="/images/splash/place-werkwise.jpeg" alt="Werkwise coworking space" class="img-responsive"/>
                </picture>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>

  <!-- Reviews -->
  <div class="section-review">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div class="row">
            <div class="col">
              <div class="text-center">
                <h2>Why remote workers use Croissant</h2>
              </div>
            </div>
          </div>

          <br/>
          <br/>

          <div class="row">
            <div class="col-12 col-md-6">
              <p>"All the good vibes of a cafe...without being subject to a cafe's music, prices or the random patron who asks: 'Hey dude, you writing a screenplay, too?'"</p>
              <h3>Bryan L, Freelance Journalist</h3>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-md-6">
              <p>"I love the fact that I can drop into spaces for two hours and then get up and go somewhere else to a meeting, and then wherever I am, look at the map, and be by a new space."</p>
              <h3>Ava R, Strategy Consultant</h3>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-md-6">
              <p>"Croissant moves straight to my home screen when I’m in the US for work. Different office every day is awesome."</p>
              <h3>Jeremy B, Founder of Emojipedia</h3>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-md-6  hide-sm hide-md">
              <p>"it's an office anywhere you need it in the city for far less than you'd pay for a co-working membership. If you don't need a desk 9-5 everyday, I'd highly recommend checking it out."</p>
              <h3>Justin G, Attorney</h3>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-md-6  hide-sm hide-md">
              <p>"I love croissant &#60;3 You just need to check in on the app and say that you are a Croissant member to the front desk and you can feel free to work."</p>
              <h3>Laura W, Engineer at Spotify</h3>
              <br/>
              <br/>
            </div>
            <div class="col-12 col-md-6  hide-sm hide-md">
              <p>"My colleague and I are loving the ability to jump around from different locations in the city and explore beautiful new creative spaces."</p>
              <h3>Jessica P, Creative Director at JPD Studios</h3>
              <br/>
              <br/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>

  <!-- Cities -->
  <div class="section-cities">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col">
          <div class="text-center">
            <h2>Where we are</h2>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-10 offset-lg-1">
          <div class="row">
            <div class="col-12 col-sm-12 col-md-6">
              <a routerLink="/discover/new-york">
                <div class="city-name" style="background-image: url(/images/splash/cities/nyc.jpg)">
                  <h2 class="caption">New York City</h2>
                </div>
              </a>
              <br/>
            </div>

            <div class="col-12 col-sm-6 col-md-3">
              <a routerLink="/discover/san-francisco">
                <div class="city-name" style="background-image: url(/images/splash/cities/sf.jpeg); background-position: 13% 50%;">
                  <h2 class="caption">SF Bay Area</h2>
                </div>
              </a>
              <br/>
            </div>

            <div class="col-12 col-sm-6 col-md-3">
              <a routerLink="/discover/boston">
                <div class="city-name" style="background-image: url(/images/splash/cities/boston.jpg); background-position: 10% 50%;">
                  <h2 class="caption">Boston</h2>
                </div>
              </a>
              <br/>
            </div>

            <div class="col-12 col-sm-6 col-md-3 hide-sm hide-md">
              <a routerLink="/discover/chicago">
                <div class="city-name" style="background-image: url(/images/splash/cities/chicago.jpeg)">
                  <h2 class="caption">Chicago</h2>
                </div>
              </a>
              <br/>
            </div>

            <div class="col-12 col-sm-6 col-md-3 hide-sm hide-md">
              <a routerLink="/discover/los-angeles">
                <div class="city-name" style="background-image: url(/images/splash/cities/la.jpeg)">
                  <h2 class="caption">Los Angeles</h2>
                </div>
              </a>
              <br/>
            </div>

            <div class="col-12 col-sm-12 col-md-6 hide-sm hide-md">
              <a routerLink="/discover/london">
                <div class="city-name" style="background-image: url(/images/splash/cities/london.jpg)">
                  <h2 class="caption">London</h2>
                </div>
              </a>
              <br/>
            </div>

            <div class="col-12 col-sm-6 col-md-6">
              <a routerLink="/discover/barcelona">
                <div class="city-name" style="background-image: url(/images/splash/cities/barcelona.jpg); background-position: 40% 81%;">
                  <h2 class="caption">Barcelona</h2>
                </div>
              </a>
              <br/>
            </div>

            <div class="col-12 col-sm-6 col-md-3">
              <a routerLink="/discover/lisbon">
                <div class="city-name" style="background-image: url(/images/splash/cities/lisbon.jpg); background-position: 70% 50%;">
                  <h2 class="caption">Lisbon</h2>
                </div>
              </a>
              <br/>
            </div>

            <div class="col-12 col-sm-12 col-md-3">
              <a routerLink="/discover/berlin">
                <div class="city-name" style="background-image: url(/images/splash/cities/berlin.jpeg); background-position: 10% 50%;">
                  <h2 class="caption">Berlin</h2>
                </div>
              </a>
              <br/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-10 offset-lg-1">

          <div class="row">
            <div class="col-12 col-sm-3">
              <p><strong>&amp; many more...</strong></p>
            </div>

            <div class="col-4 col-sm-3">
              <p>🇳🇱<a href="/discover/amsterdam">Amsterdam</a></p>
              <p>🇷🇴<a href="/discover/bucharest">Bucharest</a></p>
              <p>🇦🇷<a href="/discover/buenos-aires">Buenos Aires</a></p>
              <p>🇺🇸<a href="/discover/columbus">Columbus</a></p>
              <p>🇩🇪<a href="/discover/hamburg">Hamburg</a></p>
            </div>
            <div class="col-4 col-sm-3">
              <p>🇪🇸<a href="/discover/madrid">Madrid</a></p>
              <p>🇺🇸<a href="/discover/miami">Miami</a></p>
              <p>🇫🇷<a href="/discover/paris">Paris</a></p>
              <p>🇺🇸<a href="/discover/philadelphia">Philadelphia</a></p>
              <p>🇵🇹<a href="/discover/porto">Porto</a></p>
            </div>
            <div class="col-4 col-sm-3">
              <p>🇳🇱<a href="/discover/rotterdam">Rotterdam</a></p>
              <p>🇺🇸<a href="/discover/san-diego">San Diego</a></p>
              <p>🇮🇱<a href="/discover/tel-aviv">Tel Aviv</a></p>
              <p>🇨🇦<a href="/discover/toronto">Toronto</a></p>
              <p>🇺🇸<a href="/discover/washington-dc">Washington, D.C.</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>

  <!-- Press -->
  <div class="section-press">
    <br/>
    <br/>
    <br/>

    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-10 offset-lg-1">
          <div class="row">
            <div class="col">
              <div class="text-center">
                <a target="_blank" href="https://www.forbes.com/sites/zarastone/2016/09/14/croissant-wants-to-be-the-uber-for-coworking-spaces">
                  <img style="max-width: 140px;" src="/images/splash/press/forbes.png" alt="Forbes logo"/>
                </a>
              </div>
              <br/>
              <br/>
            </div>
            <div class="col">
              <div class="text-center">
                <a target="_blank" href="https://www.forbes.com/sites/zarastone/2016/09/14/croissant-wants-to-be-the-uber-for-coworking-spaces">
                  <img style="max-width: 180px;" src="/images/splash/press/techcrunch.png" alt="TechCrunch logo"/>
                </a>
              </div>
              <br/>
              <br/>
            </div>
            <div class="col">
              <div class="text-center">
                <a target="_blank" href="https://www.psfk.com/2016/04/startup-ensures-you-will-never-be-tired-of-your-office-space.html">
                  <img style="max-width: 60px;" src="/images/splash/press/psfk.png" alt="PSFK logo"/>
                </a>
              </div>
              <br/>
              <br/>
            </div>
            <div class="col">
              <div class="text-center">
                <a target="_blank" href="https://www.brit.co/croissant-coworking-space-membership/">
                  <img style="max-width: 170px;" src="/images/splash/press/britco.png" alt="Brit + Co logo"/>
                </a>
              </div>
              <br/>
              <br/>
            </div>
            <div class="col">
              <div class="text-center">
                <a target="_blank" href="https://www.nytimes.com/2017/09/19/smarter-living/work-at-home-tips-advice.html">
                  <img style="max-width: 180px;" src="/images/splash/press/nytimes.png" alt="New York Times logo"/>
                </a>
              </div>
              <br/>
              <br/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <br/>
    <br/>
    <br/>
  </div>

</div>
